/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DiscordQueryAnalyticsDash from "../../../../components/DiscordAnalytics/Queries/Analytics";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const DiscordAnalyticsQueryAnalytics = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.discordAnalytics?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <DiscordQueryAnalyticsDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default DiscordAnalyticsQueryAnalytics;
